import { apiCall, createQueryString } from "../imports"

const PREFIX = "payment/wallet-transactions"

export default {
    getTransactions(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },
}